import * as THREE from 'three'
import * as dat from 'lil-gui'
import gsap from 'gsap'

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import firefliesVertexShader from './shaders/flies/vertex.glsl'
import firefliesFragmentShader from './shaders/flies/fragment.glsl'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
let player


const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
);


// forces page to refresh at 0
history.scrollRestoration = 'manual'


if (history.scrollRestoration)
{
  history.scrollRestoration = 'manual'
}
else
{
  window.onbeforeunload = function () {
      window.scrollTo(0, 0)
  }
}


// Debug 
const debugObject = {}

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

const fog = new THREE.Fog('#0e0b1d', 1,100) // 3,100 default
scene.fog = fog

// __________________________________________

/**
 * Loaders
 */

const loadingBarElement = document.querySelector('.loading-bar')

let start = false

let loaded = false
var myElement = document.body


function noScroll(){
  window.scrollTo(0,0)
}
if (!start){
  window.addEventListener("scroll", noScroll)
}

const loadingManager = new THREE.LoadingManager(
  () => {
    gsap.delayedCall(0.5, () => {

      loadingBarElement.classList.add('ended')
      loadingBarElement.style.transform = ''

    })
  },
  
  (itemUrl, itemsLoaded, itemsTotal) => {
    const progressRatio = itemsLoaded / itemsTotal
    loadingBarElement.style.transform = `scaleX(${progressRatio})`
  
        if (progressRatio === 1 ) {

          loaded = true
          myElement.style.overflow = 'auto'
          enterButton.classList.remove('hidden');
        } else {
          enterButton.classList.add('hidden');
        }
        
    } 
)

const loadingMessageElement = document.getElementById('loadingMessage')
const enterButton = document.getElementById('enterButton')
enterButton.addEventListener('click', handleEnterButtonClick);

function handleEnterButtonClick() {
  enterButton.classList.add('clicked')
  if (loaded) {

    gsap.delayedCall(0.3, () => 
    {
      gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0 })
    })
    
    start = true
    updateCameraPosition()
    myElement.style.overflow = 'auto'
    window.removeEventListener("scroll", noScroll)
    enterButton.style.visibility = 'hidden'
    webpage.style.visibility = 'hidden'
    enterButton.remove()
    enter.play()
  }
}






function updateCameraPosition() {
  if (loaded) {
    targetCameraZ = -scrollY / sizes.height * objectsDistance;
  }
}

// Call the updateCameraPosition function when the window is resized
window.addEventListener('resize', updateCameraPosition)

// Call the updateCameraPosition function once at the beginning
updateCameraPosition()


const textureLoader = new THREE.TextureLoader(loadingManager)
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)


// _________________________________________

// LOADING SCREEN 

/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;

        void main()
        {
            gl_FragColor = vec4(0.062, 0.047, 0.098, uAlpha);
        }
    `
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)



// }
const parameters = {
  materialColorBase: '#ffafd6',
  materialColorVegetation: '#be5582',
  playerColor: '#ff8dac',
  spaceShipColor: '#b36ab1',
  woodColor: '#262051',
  animColor: '#6fb6e2',
  spaceColor: '#a6e8cd',
  toolColor: '#ff3f63',
  fogColor: '#0e0b1d',
  
}

// _________________________________________________________


// Textures 


const gradientTexture = textureLoader.load('textures/gradients/5.jpg')
gradientTexture.magFilter = THREE.NearestFilter

// Material
const material = new THREE.MeshToonMaterial({
    color: parameters.materialColorBase,
    gradientMap: gradientTexture
})

const materialVegetation = new THREE.MeshToonMaterial({
    color: parameters.materialColorVegetation,
    gradientMap: gradientTexture,
    // wireframe: true
})
const materialPlayer = new THREE.MeshToonMaterial({
    color: parameters.playerColor,
    gradientMap: gradientTexture,
    // wireframe: true
})
const materialSpaceShip = new THREE.MeshToonMaterial({
    color: parameters.spaceShipColor,
    gradientMap: gradientTexture,
    // wireframe: true
})
const materialSpace = new THREE.MeshToonMaterial({
    color: parameters.spaceColor,
    gradientMap: gradientTexture,
    // wireframe: true
})
const materialAnim = new THREE.MeshToonMaterial({
  color: parameters.animColor,
  gradientMap: gradientTexture,
})
const materialWoods = new THREE.MeshToonMaterial({
  color: parameters.woodColor,
  gradientMap: gradientTexture,
})

const materialTool = new THREE.MeshToonMaterial({
  color: parameters.toolColor,
  gradientMap: gradientTexture,
})



let playerLoaded = false;
// // LOADER WITH FAT ARROW 
let saucer
gltfLoader.load(
    'spaceship.glb',
    (gltf) =>
    {
        const foundSaucer = gltf.scene.children.find((child) => child.name === 'Player')

        saucer = foundSaucer
        saucer.material = materialPlayer
        player = saucer 
        player.material = materialPlayer
        scene.add(player)
        playerLoaded = true;
        

    }
)

// Objects
const objectsDistance = 4


 // ____________________________________________________________

const smallLightMaterial = new THREE.MeshBasicMaterial({ color: 0xffffe5} )

const worldLight = new THREE.DirectionalLight('#ffffff', 1.25)
worldLight.position.set(-2,3,15)
scene.add(worldLight)

// _________________________________________

/**
 * Particles Background
 */
const particlesCount = 5000
const positions = new Float32Array(particlesCount * 3)

for(let i = 0; i < particlesCount; i++)
{
    positions[i * 3 + 0] = (Math.random() - 0.5) * 60
    positions[i * 3 + 1] = Math.random() * 20
    positions[i * 3 + 2] = (Math.random() - 0.5) * 850
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
const particleTexture = textureLoader.load('/textures/particles/9.png')

const particlesMaterial = new THREE.PointsMaterial({
    color: parameters.materialColorBase,
    sizeAttenuation: textureLoader,
    transparent: true,
    alphaMap: particleTexture,
    size: 2
})




// Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
particles.position.set(0,10,-2)
scene.add(particles)

// ________________________________________________________________________
//  LOAD MODEL 

let ground, alienGround, alienBase, shrooms, rocks, plants, beam, spaceShip;
let planet1, planet2, planet3, planet4, planet5, sign2, text2,animFlower, animFlower1,
animFlower2, animDust, animDust1, animDust2, animEye, tree;
let message1, message2, message3, message4, message5, woods, tool1, tool2, tool3, tool4, animFlowerCenter, animDustShroom, animShroom,
message6, contact;
let modelLoaded = false;

// had enyss marsian.NY
function loadModel() {
  return new Promise((resolve, reject) => {
    gltfLoader.load('marsian9Draco.glb', function (gltf) {

        scene.add(gltf.scene)
        gltf.scene.position.set(0,-1.2,30)

        // Get each object
        const foundground = gltf.scene.children.find((child) => child.name === 'Ground')
        const foundalienBase = gltf.scene.children.find((child) => child.name === 'AlienBase')
        const foundalienGround = gltf.scene.children.find((child) => child.name === 'AlienGround')
        const foundshrooms = gltf.scene.children.find((child) => child.name === 'Shrooms')
        const foundrocks = gltf.scene.children.find((child) => child.name === 'Rocks')
        const foundplants = gltf.scene.children.find((child) => child.name === 'Plants')

        const foundAnimFlower = gltf.scene.children.find((child) => child.name === 'animFlower')
        const foundAnimFlower1 = gltf.scene.children.find((child) => child.name === 'animFlower1')
        const foundAnimFlower2 = gltf.scene.children.find((child) => child.name === 'animFlower2')
        const foundAnimDust = gltf.scene.children.find((child) => child.name === 'animDust')
        const foundAnimDust1 = gltf.scene.children.find((child) => child.name === 'animDust1')
        const foundAnimDust2 = gltf.scene.children.find((child) => child.name === 'animDust2')
        const foundAnimEye = gltf.scene.children.find((child) => child.name === 'animEye')
        
        const foundAnimFlowerCenter = gltf.scene.children.find((child) => child.name === 'animFlowerCenter')
        const foundAnimDustShroom = gltf.scene.children.find((child) => child.name === 'animDustShroom')
        const foundAnimShroom = gltf.scene.children.find((child) => child.name === 'animShroom')

        const foundbeam = gltf.scene.children.find((child) => child.name === 'LightBeam')
        const foundship = gltf.scene.children.find((child) => child.name === 'SpaceShip')

        const foundPlanet1 = gltf.scene.children.find((child) => child.name === 'Planet1')
        const foundPlanet2 = gltf.scene.children.find((child) => child.name === 'Planet2')
        const foundPlanet3 = gltf.scene.children.find((child) => child.name === 'Planet3')
        const foundPlanet4 = gltf.scene.children.find((child) => child.name === 'Planet4')
        const foundPlanet5 = gltf.scene.children.find((child) => child.name === 'Planet5')

        const foundMessage1 = gltf.scene.children.find((child) => child.name === 'Message1')
        const foundMessage2 = gltf.scene.children.find((child) => child.name === 'Message2')
        const foundMessage3 = gltf.scene.children.find((child) => child.name === 'Message3')
        const foundMessage4 = gltf.scene.children.find((child) => child.name === 'Message4')
        const foundMessage5 = gltf.scene.children.find((child) => child.name === 'Message5')
        const foundMessage6 = gltf.scene.children.find((child) => child.name === 'Message6')
        const foundSign2 = gltf.scene.children.find((child) => child.name === 'sign2')
        
        const foundWoods = gltf.scene.children.find((child) => child.name === 'Woods')
        const foundTree = gltf.scene.children.find((child) => child.name === 'Tree')
        
        const foundText2 = gltf.scene.children.find((child) => child.name === 'text2')
        const foundTool1 = gltf.scene.children.find((child) => child.name === 'Tool1')
        const foundTool2 = gltf.scene.children.find((child) => child.name === 'Tool2')
        const foundTool3 = gltf.scene.children.find((child) => child.name === 'Tool3')
        const foundTool4 = gltf.scene.children.find((child) => child.name === 'Tool4')
        
        const foundContact = gltf.scene.children.find((child) => child.name === 'Contact')

        
        ground = foundground
        alienBase = foundalienBase
        alienGround = foundalienGround
        shrooms = foundshrooms
        rocks = foundrocks
        plants = foundplants
        beam = foundbeam
        spaceShip = foundship

        planet1 = foundPlanet1
        planet2 = foundPlanet2
        planet3 = foundPlanet3
        planet4 = foundPlanet4
        planet5 = foundPlanet5

        message1 = foundMessage1
        message2 = foundMessage2
        message3 = foundMessage3
        message4 = foundMessage4
        message5 = foundMessage5
        message6 = foundMessage6

        sign2 = foundSign2
        woods = foundWoods
        tree = foundTree
        text2 = foundText2

        animFlower = foundAnimFlower
        animFlower1 = foundAnimFlower1
        animFlower2 = foundAnimFlower2
        animDust = foundAnimDust
        animDust1 = foundAnimDust1
        animDust2 = foundAnimDust2
        animEye = foundAnimEye
        animFlowerCenter = foundAnimFlowerCenter


        tool1 = foundTool1
        tool2 = foundTool2
        tool3 = foundTool3
        tool4 = foundTool4 
        
        contact = foundContact 

        woods.material = materialWoods
        tree.material = materialAnim

        animShroom = foundAnimShroom
        animDustShroom = foundAnimDustShroom

        
        // // Apply materials
        ground.material = material
        alienGround.material = material
        alienBase.material = materialVegetation
        rocks.material = material
        shrooms.material = materialVegetation
        plants.material = materialVegetation
        beam.material = smallLightMaterial
        spaceShip.material = materialSpaceShip
        planet1.material = materialSpace
        planet2.material = materialSpace
        planet3.material = materialSpace
        planet4.material = materialSpace
        planet5.material = materialSpace
        message1.material = materialSpace
        message2.material = materialSpace
        message3.material = materialSpace
        message4.material = materialSpace
        message5.material = materialSpace
        message6.material = materialSpace
        woods.material = materialWoods
        sign2.material = materialWoods
        text2.material = materialPlayer


        
        animFlower.material = materialAnim
        animFlower1.material = materialAnim
        animFlower2.material = materialAnim
        animDust.material = smallLightMaterial
        animDust1.material = smallLightMaterial
        animDust2.material = smallLightMaterial
        animEye.material = materialAnim

        tool1.material = materialTool
        tool2.material = materialTool
        tool3.material = materialTool
        tool4.material = materialTool
        
        contact.material = materialSpace

        animFlowerCenter.material = materialAnim
        animShroom.material = materialAnim
        animDustShroom.material = materialAnim
        
        spaceShip.add(sound)
        animDust2.scale.set(0.1,0.1,0.1)

        message2.scale.set(0,0,0)
        message3.scale.set(0,0,0)
        message4.scale.set(0,0,0)
        message5.scale.set(0,0,0)
        message6.scale.set(0,0,0)
        animDustShroom.scale.set(0,0,0)
        beam.scale.set(0,0,0)
        contact.scale.set(0,0,0)


      modelLoaded = true;
      resolve();
    }, undefined, reject);
  });
}


// __________________________________________________________

// Fireflies 

// geometry 
const fliesGeometry = new THREE.BufferGeometry()
const fliesCount = 1000
const positionArray = new Float32Array(fliesCount * 3)
const scaleArray = new Float32Array(fliesCount)

for(let i =0; i < fliesCount; i++)
{
    positionArray[i * 3 + 0] = (Math.random() - 0.5) * 20
    positionArray[i * 3 + 1] = Math.random() *3
    positionArray[i * 3 + 2] = (Math.random() -0.5)*8.75

    scaleArray[i] = Math.random()
}


fliesGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3))
fliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(scaleArray, 1))

const fliesMaterial = new THREE.ShaderMaterial({
    uniforms: 
    {
        uTime: { value: 0 },
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
        uSize: { value: 145 } // for equal pixel ratio 
    },
    vertexShader: firefliesVertexShader,
    fragmentShader: firefliesFragmentShader,
    transparent: true,
    blending: THREE.AdditiveBlending,
    depthWrite: false
})

const flies = new THREE.Points(fliesGeometry, fliesMaterial)
scene.add(flies)
flies.position.set(0,-0.85,-240)

const stars = new THREE.Points(particlesGeometry, fliesMaterial)
scene.add(stars)


// _______________________________________________________________

/**
 * Size
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}


window.addEventListener('resize', () => {
  if (!isMobile) {  /// temporary fix to compensate for toolbar creating glitches in scroll
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;

    // update fireflies
    fliesMaterial.uniforms.uPixelRatio.value = Math.min(
      window.devicePixelRatio,
      2
    )
  }

})

/**
 * Camera
 */


// Group
const cameraGroup = new THREE.Group()
cameraGroup.position.set(0, 0, 0) 
scene.add(cameraGroup)


// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 0, 0) 
cameraGroup.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

renderer.domElement.addEventListener('click', function () {
    // Check if the sound is not already playing
    if (!sound.isPlaying) {
      sound.play();
    }
  });

debugObject.clearColor = '#0e0b1d'
renderer.setClearColor(debugObject.clearColor)

// __________________________________________________________________


// ADUIO 

const listener = new THREE.AudioListener()
camera.add(listener)

const sound = new THREE.PositionalAudio(listener)
const ambience = new THREE.Audio(listener)
const poke = new THREE.Audio(listener)
const pick = new THREE.Audio(listener)
const scrollSound = new THREE.Audio(listener)
const fix = new THREE.Audio(listener)
const drop = new THREE.Audio(listener)
const enter = new THREE.Audio(listener)
const bush = new THREE.Audio(listener)

const audioLoader = new THREE.AudioLoader();
audioLoader.load( './audio/glitch.mp3', function( buffer ) {
	sound.setBuffer( buffer )
	sound.setLoop( true )
	sound.setVolume( 0.2 )
  sound.setRefDistance(5)
	sound.play()
})

audioLoader.load( './audio/ambience.mp3', function( buffer ) {
	ambience.setBuffer( buffer )
	ambience.setLoop( true )
	ambience.setVolume( 0.2 )
	ambience.play()  

})

audioLoader.load( './audio/pick.mp3', function( buffer ) {
	pick.setBuffer( buffer )
	pick.setLoop( false )
	pick.setVolume( 0.5 )
  pick.currentTime = 1

})

audioLoader.load( './audio/ufo2.mp3', function( buffer ) {
	scrollSound.setBuffer( buffer )
	scrollSound.setLoop( false )
	scrollSound.setVolume( 0.05 )
  scrollSound.startTime = 0.5

})
audioLoader.load( './audio/fix.mp3', function( buffer ) {
	fix.setBuffer( buffer )
	fix.setLoop( false )
	fix.setVolume( 0.8 )

})
audioLoader.load( './audio/drop.mp3', function( buffer ) {
	drop.setBuffer( buffer )
	drop.setLoop( false )
	drop.setVolume( 0.4 )

})
audioLoader.load( './audio/enter.wav', function( buffer ) {
	enter.setBuffer( buffer )
	enter.setLoop( false )
	enter.setVolume( 0.4 )

})
audioLoader.load( './audio/bush.mp3', function( buffer ) {
	bush.setBuffer( buffer )
	bush.setLoop( false )
	bush.setVolume( 1 )

})

// RAYCASTER 
const raycaster = new THREE.Raycaster()


// CLICK EVENT ______________________________________________________

let isPlaying = false
let isPlayingScroll = false
window.addEventListener('click', () =>
{

    handlePlayerInteraction()
    
    
    
})
window.addEventListener('touchstart', () =>
{
    handlePlayerInteraction()
    
})


// Collecting Tools 

let collectedTools = 0
let repaired = false

function handlePlayerInteraction() {
    if(currentIntersect)
    {

        if(currentIntersect.object === player)
        {
            if(isPlaying)
            {
                isPlaying = true
            }
  
            isPlaying = true
        }
        else if(currentIntersect.object === spaceShip)
        {
          if(collectedTools === 4)
          {
            fix.play()
            gsap.to(beam.scale, {
              x: 1,
              y: 1,
              z: 1,
              duration: 1.5,
              ease: 'power2.inout'
            }),
            gsap.to(message6.scale, {
              x: 1,
              y: 1,
              z: 1,
              duration: 2.5,
              ease: 'power2.out'
            }),
            gsap.to(message5.scale, {
              x: 0,
              y: 0,
              z: 0,
              duration: 0.5,
              ease: 'power2.out'
            }),
            gsap.to(contact.scale, {
              x: 1,
              y: 1,
              z: 1,
              duration: 3,
              ease: 'power2.out'
            }),
            repaired = true
          }
          else{
          gsap.to(spaceShip.rotation, {
            x: -0.25,
            y: +0.1,
            z: +0.2,
            duration: 0.5,
            ease: 'power2.inout'
          }),
          gsap.to(beam.rotation, {
            x: -0.25,
            y: +0.1,
            z: +0.2,
            duration: 0.5,
            ease: 'power2.inout'
          })
        }
        }
        else if(currentIntersect.object === animFlower)
          {
            drop.play()
            
            gsap.to(animDust.position, {
              x: -1.5,
              y: 2.1,
              z: -358,
              duration: 1.5,
              ease: 'power2.inout'
            })

            gsap.to(animDust.scale, {
              x: 1.05,
              y: 1.05,
              z: 1.05,
              duration: 0.5,
              ease: 'power2.inout'
            })
            
          }
          else if(currentIntersect.object === animFlower1)
          {
            
            drop.play()

            gsap.to(animDust1.position, {
              x: -1,
              y: 1.5,
              z: -355.5,
              duration: 1.5,
              ease: 'power2.inout'
            })
            
          }
          else if(currentIntersect.object === animFlower2)
          {
            drop.play()


            gsap.to(animDust2.position, {
              x: 2.4,
              y: 1.5,
              z: -356,
              duration: 2.5,
              ease: 'power2.inout'
            })

            gsap.to(animDust2.scale, {
              x: 1.002,
              y: 1.002,
              z: 1.002,
              duration: 0.5,
              ease: 'power2.inout'
            })
            
          }

          else if(currentIntersect.object === animEye)
          {
            bush.play()

            gsap.to(animEye.position, {
              x: -1.8,
              y: 0.35,
              z: -355,
              duration: 1.8,
              ease: 'power16.inout'
            })

            
          }

          else if(currentIntersect.object === tool1)
          {
            pick.play()
            gsap.to(tool1.scale, {
              x: 0,
              y: 0,
              z: 0,
              duration: .2,
              ease: 'power2.inout'
            })
            collectedTools++   
            
          }

          else if(currentIntersect.object === tool2)
          {
            pick.play()
            gsap.to(tool2.scale, {
              x: 0,
              y: 0,
              z: 0,
              duration: .2,
              ease: 'power2.inout'
            })
            collectedTools++   
            
          }

          else if(currentIntersect.object === tool3)
          {
            pick.play()
            gsap.to(tool3.scale, {
              x: 0,
              y: 0,
              z: 0,
              duration: .2,
              ease: 'power2.inout'
            })
            collectedTools++   
            
          }

          else if(currentIntersect.object === tool4)
          {
            pick.play()
            gsap.to(tool4.scale, {
              x: 0,
              y: 0,
              z: 0,
              duration: .2,
              ease: 'power2.inout'
            })
            collectedTools++            
          }

          
          else if(currentIntersect.object === animFlowerCenter)
          {
            bush.play()
            gsap.to(animFlowerCenter.scale, {
              x: 0.5,
              y: 0.5,
              z: 0.5,
              duration: 1.5,
              ease: 'power2.inout'
            })          
          }
          else if(currentIntersect.object === tree)
          {
            
            bush.play()
            gsap.to(tree.position, {
              x: -1.2,
              y: 0.1,
              z: -273.5,
              duration: 1.5,
              ease: 'power2.inout'
            })          
          }
          else if(currentIntersect.object === animShroom)
          {
            
            drop.play()
            gsap.to(animDustShroom.scale, {
              x: 1,
              y: 1,
              z: 1,
              duration: 1.5,
              ease: 'power2.inout'
            })          
          }
          else if(currentIntersect.object === contact)
          {
            
            enter.play()
            window.open('https://www.fridawiig.xyz/')
        
          }
        }
    }


// __________________________________________________________________

function animateSigns() {
  if (player && player.position.z > -19 && player.position.z < -18) {
    console.log('hello developer (:')
    
    gsap.to(message2.scale, {
      x: 1,
      y: 1,
      z: 1,
      duration: 1.5,
      ease: 'power2.out'
    })
  }
  else if (player && player.position.z > -35 && player.position.z < -34) {
    gsap.to(message3.scale, {
      x: 1,
      y: 1,
      z: 1,
      duration: 1.5,
      ease: 'power2.out'
    })
  }
  else if (player && player.position.z > -67 && player.position.z < -66) {
    console.log('hope you enjoy this lil experiment')

    gsap.to(message4.scale, {
      x: 1,
      y: 1,
      z: 1,
      duration: 1.5,
      ease: 'power2.out'
    })
  }
  else if (player && player.position.z > -317 && player.position.z < -310 && !repaired) {
    gsap.to(message5.scale, {
      x: 1,
      y: 1,
      z: 1,
      duration: 2.5,
      ease: 'power2.out'
    })
  }
}


/**
 * Scroll
 */

let scrollY = window.scrollY
let lastScrolly

// ANIMATE PLAYER ON SCROLL 
  
  let oldScrollY = 0
  let isScrolling = false
  let scrollTimer

  // Handle scroll event
  window.addEventListener('scroll', () => {

    scrollY = window.scrollY
    lastScrolly = scrollY
    

    animateSigns()
    if(isPlayingScroll)
    {
        scrollSound.stop()
        scrollSound.play()
        isPlayingScroll = true
    }

    scrollSound.play() 
    isPlayingScroll = true

    if (!scrollSound.isPlaying) {
      scrollSound.play()
    }

    // Check if the player is loaded
    if (playerLoaded) {
      const newScrollY = window.scrollY;


      // Check if there is scroll
      if (newScrollY > oldScrollY) {
        // Scroll is happening, animate the rotation to (2, 0, 0)

        gsap.to(player.rotation, {
          x: -0.25,
          y: 0,
          z: 0,
          duration: 0.5,
          ease: 'power2.inout'
        });

      } else if (newScrollY < oldScrollY)  {
        gsap.to(player.rotation, {
          x: 0.25,
          y: 0,
          z: 0,
          duration: 0.5,
          ease: 'power2.out'
        });
      }
      oldScrollY = newScrollY

      clearTimeout(scrollTimer)

      // Set a new scroll timer to detect when scrolling stops
      scrollTimer = setTimeout(() => {
        isScrolling = false;
        gsap.to(player.rotation, {
          x: 0,
          y: 0,
          z: 0,
          duration: 0.8,
          ease: 'power2.out'
        })
      }, 200)
  
      // Set isScrolling to true to indicate that scrolling is happening
      isScrolling = true;
      

    }
  })

  var scrollPosition = window.scrollY

// Invert  arrow keys
window.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowUp') {
        scrollPosition += 100
        
        // Scroll to the new position
        window.scrollTo(0, scrollPosition)
        
        // Prevent the default arrow key behavior
        event.preventDefault()
    } else if (event.key === 'ArrowDown') {
        scrollPosition -= 100
        
        // Scroll to the new position
        window.scrollTo(0, scrollPosition)
        
        event.preventDefault()
    }
})


 
/**
 * Cursor
 */
const cursor = {} // for parralax
cursor.x = 0
cursor.y = 0

// Raycast Mouse 
const mouse = new THREE.Vector2() // for raycaster 

window.addEventListener('mousemove', (event) =>
{
    cursor.x = event.clientX / sizes.width -0.5
    cursor.y = event.clientY / sizes.height -0.5
    mouse.x = event.clientX / sizes.width *2 -1
    mouse.y = -(event.clientY / sizes.height * 2 -1)
    
})

let targetCameraZ
let lerpFactor = 0.075

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
let currentIntersect = null

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // // Cast From mouse
    raycaster.setFromCamera(mouse, camera)
    // // Caster 

    const objectsTest = [player, spaceShip, sign2, animFlower, animFlower1, animFlower2, animEye, tool1, tool2, tool3, tool4, tree, animShroom, animFlowerCenter, contact]
    const intersects = raycaster.intersectObjects(objectsTest)
    
    
  if(intersects.length)
  {
    if(currentIntersect === null)
    {
        
    }
    currentIntersect = intersects[0]
    
  }
  else
  {
    if(currentIntersect)
    {

    }
    currentIntersect = null
    
  }

  const scaleShip = raycaster.intersectObject(player)

  if(scaleShip.length)
  {
    player.scale.set(1.1,1.1,1.1)
  }
  else
  {
    player.scale.set(1,1,1)
    
  }

  const playText = raycaster.intersectObject(sign2)

  if(playText.length)
  {

    sign2.rotation.y = -0.25
    text2.rotation.y = -0.25
    
  }
  else
  {
    sign2.rotation.y = 0
    text2.rotation.y = 0

    
  }


    // Animate camera

    if (loaded === false) {
        camera.position.z = 0
      } else {
        targetCameraZ = -scrollY / sizes.height * objectsDistance
      }

      camera.position.z = THREE.MathUtils.lerp(camera.position.z, targetCameraZ, lerpFactor)



    player.position.set(0, 0,(camera.position.z -4))
    const parallaxX = cursor.x * 0.5
    const parallaxY = - cursor.y * 0.5
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 5 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 5 * deltaTime

    // Animate floating player
    player.position.y = Math.sin(elapsedTime)*0.06 - 0.7
    player.rotation.y = -elapsedTime

    // ANIMATION LOADED MODELS
    
    if (modelLoaded) {

        // Animating Planets
        planet1.rotation.x = Math.PI * (elapsedTime)*0.01 
        planet1.rotation.y = Math.PI * (elapsedTime)*0.02
        planet2.rotation.x = Math.PI * (elapsedTime)*0.01 
        planet2.rotation.y = Math.PI * (elapsedTime)*0.02
        planet3.rotation.x = Math.PI * (elapsedTime)*0.03 
        planet3.rotation.y = Math.PI * (elapsedTime)*0.02
        planet4.rotation.x = Math.PI * (elapsedTime)*0.01 
        planet4.rotation.y = Math.PI * (elapsedTime)*0.05
        planet5.rotation.x = Math.PI * (elapsedTime)*-0.01 
        planet5.rotation.y = Math.PI * (elapsedTime)*0.03
        planet5.position.y = Math.sin(elapsedTime) * 0.05 + 8
        beam.rotation.x = Math.sin(elapsedTime) * 0.075
        beam.rotation.z = Math.sin(elapsedTime) * 0.075

    }
    
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

    // Time passed to shaders 
    fliesMaterial.uniforms.uTime.value = elapsedTime

}

loadModel().then(() => {
    // Start the animation loop
    tick()
  }).catch((error) => {
    // Handle any loading errors
    console.error(error)
  })
  